var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-upload", {
    staticClass: "image-uploader-multi",
    attrs: {
      action: "".concat(_vm.path, "/file/upload"),
      headers: {
        Authorization: "Bearer " + _vm.token
      },
      "show-file-list": true,
      "list-type": "picture-card",
      "file-list": _vm.imageUrl,
      "on-success": _vm.handleImageSuccess,
      "before-upload": _vm.beforeImageUpload,
      "before-remove": _vm.beforeRemove,
      multiple: true
    }
  }, [_c("i", {
    staticClass: "el-icon-plus",
    attrs: {
      slot: "default"
    },
    slot: "default"
  })])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };